
import { React } from "react";
import loadings from "../../../src/components/Images/loading/gif_loadings.gif";
import { useMyContext } from "../../components/Provider/CommonProvider";
import "../../components/CommonComponents/Admin.css"
import MessageBox from "../../components/CommonComponents/MessageBox";

function Defaultloadinggif({ className }) {
    const { loadingGifVideo } = useMyContext()
    return (
        <>
            {loadingGifVideo !== null ?
                <div className={` ${className} d-flex align-items-center justify-content-center `}>
                    <img src={loadingGifVideo} style={{ width: "50px", height: "50px", objectFit: "contain" }} className="" alt="processing" />
                    <MessageBox text="Loading..." />
                </div>
                :
                <div className={`${className} d-flex align-items-center justify-content-center `}>
                    <img src={loadings} style={{ width: "50px", height: "50px", objectFit: "contain" }} className="" alt="processing" />
                    <MessageBox text="Loading..." />
                </div>
            }
        </>
    );
}

export default Defaultloadinggif;
